export enum ReferenceType {
  LOCAL = 'Local',
  GLOBAL = 'Global',
}
